import React, { useCallback, useState } from 'react'
import {
  Box,
  Text,
  IcoMoon,
  Form,
  ThemeContextExtend,
  BrandLogoIcon,
  MailIcon,
} from '@usap/uicomponents'
import FormTheme from './config/form-theme'
import { subscribeSchema } from './ValidationSchema'
import validate from '../../helpers/validation'
import {
  BrandLogo, CouponsFormButton,
  CouponsFormButtonContainer,
  CouponsFormContainer,
  CouponsFormHeading,
  CouponsFormInnerContainer,
  CouponsFormLogoContainer,
  CouponsFormMainContainer,
  CouponsFormTextButton,
  CouponsFormTextInput,
  CouponsHeaderContainer,
  InfoMessageText,
} from './style/CouponsForm.css'

export default function CouponsForm({
  onSubscribe,
  message,
  setMessage,
  infoMessage,
  isCart = false,
}) {
  const [errors, setError] = useState({})
  const [formData, setFormData] = useState({
    emailAddress: '',
    source: 'coupons_page',
  })

  const onInputChangeHandler = (name, value) => {
    setMessage('')
    setError({
      ...errors,
      [name]: '',
    })
    setFormData({
      ...formData,
      [name]: value,
    })
  }

  const onFormSubmit = useCallback(() => {
    const hasError = validate(formData, subscribeSchema(formData))
    if (hasError) {
      return setError(hasError)
    }
    return onSubscribe(formData)
  }, [formData, onSubscribe])

  return (
    <CouponsFormMainContainer round isCart={isCart}>
      <CouponsFormInnerContainer
        alignSelf="center"
        height="45px"
      >
        <BrandLogo
          icon={BrandLogoIcon}
        />
      </CouponsFormInnerContainer>

      <>
        <CouponsHeaderContainer width="100%">
          <CouponsFormHeading
            textAlign="center"
            title="CARPARTS.COM COUPONS"
          />
        </CouponsHeaderContainer>

        <Box width="100%">
          <InfoMessageText
            textAlign="center"
            size="16px"
          >
            {infoMessage}
          </InfoMessageText>
        </Box>

        <ThemeContextExtend value={FormTheme}>
          <Form id="submitForm" onSubmit={onFormSubmit}>
            <Box>
              <CouponsFormContainer
                width="100%"
                background="white"
                height="62px"
                direction="row"
                align="center"
                round="50px"
              >
                <CouponsFormLogoContainer align="center">
                  <IcoMoon icon={MailIcon} color="dark-2" size="30px" />
                </CouponsFormLogoContainer>

                <Box width="80%" align="center">
                  <CouponsFormTextInput
                    plain
                    id="emailAddress"
                    name="emailAddress"
                    type="email"
                    value={formData.emailAddress}
                    placeholder="Enter Your Email Address"
                    aria-label="email"
                    onChange={event => {
                      onInputChangeHandler('emailAddress', event.target.value)
                    }}
                  />
                </Box>
              </CouponsFormContainer>

              <Box width="100%">
                <Text color="#f44635" size="xsmall">
                  {errors.emailAddress}
                </Text>
              </Box>
            </Box>

            <CouponsFormButtonContainer>
              <CouponsFormButton
                id="submit"
                form="submitForm"
                primary
                type="submit"
                custom
                hideBorder
                label={(
                  <CouponsFormTextButton
                    color="white"
                    weight="bold"
                  >
                    SIGN UP NOW
                  </CouponsFormTextButton>
                )}
              />

              <Box width="100%" align="center">
                <Text color="#f44635" size="xsmall">
                  {message}
                </Text>
              </Box>
            </CouponsFormButtonContainer>
          </Form>
        </ThemeContextExtend>
      </>
    </CouponsFormMainContainer>
  )
}
